var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(
      _vm.employeeAbsence.length ||
      _vm.needsToConfirmAccount(_vm.employee) ||
      !_vm.employeeWorksDate ||
      (_vm.calculateRemainingWorkableMinutes <= 0 &&
        !_vm.isZeroHourEmployee(_vm.employee))
    )?_c('div',{staticClass:"all:flex flex-column gap-4"},[(_vm.needsToConfirmAccount(_vm.employee))?_c('InlineDialog',{attrs:{"type":"error","header":_vm.$t('info.unverifiedEmail.notAcceptedInvite', {
          employee: _vm.employee.firstName,
        }),"message":_vm.$t('info.unverifiedEmail.notificationsNotReceived'),"icon":_vm.Icon.Envelope}}):_vm._e(),(_vm.employeeAbsence.length)?_c('InlineDialog',{attrs:{"type":"error","header":_vm.$t('absence.employeeOffSick', { name: _vm.employee.firstName }),"icon":_vm.IconMap.Absence}}):_vm._e(),(!_vm.employeeWorksDate)?_c('InlineDialog',{attrs:{"header":_vm.$t('schedule.nonWorkingDay'),"message":_vm.$t('schedule.error.employeeDoesntWorkThisDay', {
          employee: _vm.employee.firstName,
        }),"icon":_vm.Icon.TriangleExclamation,"type":"warning"}}):_vm._e(),(
        _vm.calculateRemainingWorkableMinutes <= 0 &&
        _vm.showWorkingHoursWarning &&
        !_vm.isZeroHourEmployee(_vm.employee)
      )?_c('InlineDialog',{attrs:{"header":_vm.$t('info.heading.maxHoursReached'),"message":_vm.$t('schedule.error.employeeReachedWeeklyHours', {
          employee: _vm.employee.firstName,
          workingHours: _vm.calculateHours(_vm.employeeWeekTotalWorkedMinutes / 60),
          maxHours: _vm.calculateHours(_vm.employee.workingHoursPerWeek),
        }),"icon":_vm.Icon.TriangleExclamation,"type":"error"}}):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }